
import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
//
import ProtectedRoute, { SuperuserRoute, AdminRoute } from "./shared/routes/ProtectedRoute";
import GlobalLayout from "./components/common/layout/GlobalLayout";
//
// import Registration from "./auth/pages/Registration";
import LandingPage from "./auth/pages/LandingPage";
import OAuthCallback from "./auth/pages/OAuthCallback";
import ResetPasswordPage from "./auth/pages/ResetPasswordPage";
//
import './App.css';
import { SnackbarProvider } from "shared/contexts/SnackbarContext"; // Import the context
import { NotificationProvider } from "components/comm/notifications/contexts/NotificationContext";
import { UserProvider, useUserContext } from "shared/contexts/UserContext"; // Import UserProvider
import { LocaleProvider, useLocale } from "shared/contexts/LocaleContext";
import { FollowCacheProvider } from "shared/contexts/FollowCacheContext"; // Import FollowCacheProvider
import { UserStatusProvider } from "shared/contexts/UserStatusContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import 'dayjs/locale/en-gb';
import 'dayjs/locale/sv';
import ErrorBoundary from "components/common/ErrorBoundary";
import NotFoundPage from "components/common/NotFoundPage";
import Organization from "./components/collab/consortium/pages/Organization"
// funding pages
import FundingCallsPage from "./components/collab/funding/FundingCallsPage";
import CallDetailPage from "./components/collab/funding/CallDetailPage";
import AllSuggestedExpertsPage from "./components/collab/funding/AllSuggestedExpertsPage";
import AllRelevantCalls from "./components/funding/AllRelevantCalls";
import MySuggestions from './components/social/profile/components/suggestions/MySuggestions';
import SuggestionList from './components/social/profile/components/suggestions/SuggestionList';
import AllSuggestions from './components/social/profile/components/suggestions/AllSuggestions';
import SendEmailsPage from './components/admin/trash/SendEmailsPage';
//


import AlternativeProfileFeed from 'components/social/profile/AlternativeProfileFeed';
import PostPage from 'components/social/feed/PostPage';
import PublicPostPage from 'components/social/feed/PublicPostPage';

import EnhancedConsortiumList from 'components/collab/consortium/EnhancedConsortiumList';
import EnhancedConsortiumDetail from 'components/collab/consortium/EnhancedConsortiumDetail';
import EditConsortium from 'components/collab/consortium/EditConsortium';
import CollaborationHub from 'components/collab/collaboration/CollaborationHub';
import ProfilePage from 'components/social/profile/ProfilePage';
import ReflectionArticlePage from 'components/social/profile/reflections/ReflectionArticlePage';
import ReflectionsPage, { ItemReflectionsRedirect } from 'components/social/profile/reflections/ReflectionsPage';
import OrganizationPage from 'components/social/organization/OrganizationPage';
import LabPage from 'components/collab/lab/LabPage';
import PositionPage from 'components/collab/positions/PositionPage';
import AccountBlockedPage from 'components/common/AccountBlockedPage';
import DepartmentPage from 'components/social/organization/DepartmentPage';


import HorizonEuropeIntegration from 'components/collab/funding/HorizonEuropeIntegration';
import ModernSuggestionsPage from 'components/comm/suggestions/ModernSuggestionsPage';
import OrganizationsPage from 'components/social/organization/OrganizationsPage';
import EnhancedNotificationSystem from 'components/comm/notifications/EnhancedNotificationSystem';
import VerifyMembershipsPanel from 'components/admin/VerifyMembershipsPanel';
import AdminReportsPage from 'components/admin/AdminReportsPage';
import AdminAnalyticsPage from 'components/admin/AdminAnalyticsPage';
import AdminAICreditsPage from 'components/admin/AdminAICreditsPage';
import AdminCallUpdatesPage from 'components/admin/AdminCallUpdatesPage';
import AdminProfileRemindersPage from 'components/admin/AdminProfileRemindersPage';
import AdminBulkEmailPage from 'components/admin/AdminBulkEmailPage';
import AdminReleasesPage from 'components/admin/AdminReleasesPage';
import FollowedEntitiesPage from 'components/social/FollowedEntitiesPage';
import { MessagesPage, SendMessagePage } from 'components/comm/messages';
import ProposalWriter from 'components/collab/consortium/proposal/ProposalWriter';  
import SettingsPage from 'components/settings/SettingsPage';
import EventsPage from 'components/collab/events/EventsPage';
import EventDetailPage from 'components/collab/events/EventDetailPage';
import MyCalendarPage from 'components/collab/events/MyCalendarPage';
import InterestsPage from 'components/collab/interests/InterestsPage';
import WorksPage from 'components/collab/works/WorksPage';
import ConnectionsPage from 'components/social/connections/ConnectionsPage';
import { Send } from '@mui/icons-material';
import BlogPage from 'components/common/BlogPage';
import NotificationTestPage from 'components/admin/NotificationTestPage';


function SplashDismisser() {
  const { loading } = useUserContext();
  useEffect(() => {
    if (loading) return;
    const el = document.getElementById('otable-splash');
    if (!el) return;
    el.style.opacity = '0';
    el.style.transition = 'opacity 0.5s ease';
    const t = setTimeout(() => el.remove(), 500);
    return () => clearTimeout(t);
  }, [loading]);
  return null;
}

// Maps our date_format preference to a dayjs locale string.
// dayjs locales control date picker display format and month/day name language.
const DAYJS_LOCALE = { dmy: 'en-gb', mdy: 'en', ymd: 'sv' };

function MuiLocaleProvider({ children }) {
  const { datePref } = useLocale();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={DAYJS_LOCALE[datePref] || 'en-gb'}>
      {children}
    </LocalizationProvider>
  );
}

function RegisterRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('signup', '1');
  return <Navigate to={`/login/?${params.toString()}`} replace />;
}

const App = () => {
  return (
    <ErrorBoundary>
    <UserProvider>
      <LocaleProvider>
      <MuiLocaleProvider>
      <SplashDismisser />
      <UserStatusProvider>
      <FollowCacheProvider>
      <SnackbarProvider>
        <NotificationProvider>

<Routes>
  
  {/* Public Routes - No Layout */}
  <Route path="/login/" element={<LandingPage />} />
  {/* Old sign-up links (consortium invitation emails): the form lives on the landing page */}
  <Route path="/register/" element={<RegisterRedirect />} />
  <Route path="/auth/callback/" element={<OAuthCallback />} />
  <Route path="/account-blocked/" element={<ProtectedRoute><AccountBlockedPage /></ProtectedRoute>} />
  {/* A lab's public page: no account, no app bar or sidebar (only labs their PI made public) */}
  <Route path="/p/lab/:labId/" element={<LabPage publicMode />} />
  <Route path="/labs/:labKey/" element={<LabPage publicMode />} />
  {/* A researcher's public Reflections page and their public reflections: no account, no app around them */}
  <Route path="/p/reflections/:userId/" element={<ReflectionsPage publicMode />} />
  <Route path="/p/reflection/:objectId/" element={<ReflectionArticlePage publicMode />} />
  {/* A post its author made public: open to anyone on the web, no account */}
  <Route path="/p/post/:postId/" element={<PublicPostPage />} />
  {/* The PI's preview of the public page (also before it is public) */}
  <Route path="/lab/:labId/preview/" element={<ProtectedRoute><LabPage publicMode preview /></ProtectedRoute>} />
  <Route path="/reset-password/:uid/:token/" element={<ResetPasswordPage />} />
  <Route path="/blog/" element={<BlogPage />} />
  <Route path="/blog/:slug/" element={<BlogPage />} />


<Route
        path="/profile/:profileId/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <ProfilePage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

      {/* the older page of one item's reflections: now the Reflections page filtered to that item */}
      <Route path="/profile/:userId/reflections/:contentType/:objectId/" element={<ItemReflectionsRedirect />} />


      <Route
        path="/profile/:userId/reflections/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <ReflectionsPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/reflections/:objectId/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <ReflectionArticlePage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />


      <Route
        path="/consortium/:consortiumId/proposals/:proposalId/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <ProposalWriter />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/consortium/:consortiumId/publications/:proposalId/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                {/* Publications use the same writer, adapted by document_type */}
                <ProposalWriter />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />


<Route
        path="/settings/"
        element={
          <ProtectedRoute>
            <GlobalLayout hasSideBar={true}>
                <SettingsPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

      {/* Public User Profile */}
      {/* <Route
        path="/user/:userId"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <PublicProfilePage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      /> */}

<Route
        path="/feed/:profileId/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <AlternativeProfileFeed />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/feed/:profileId/relevant-calls"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <AllRelevantCalls />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />


<Route
        path="/feed/:profileId/posts/:postId/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <PostPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />


<Route
        path="/consortium/"
        element={
          <ProtectedRoute>
            <GlobalLayout bgcolor="#fff">
                <EnhancedConsortiumList />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />




<Route
        path="/"
        element={
          <ProtectedRoute>
            <GlobalLayout bgcolor="#fff">
                <EnhancedConsortiumList />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

{/* <Route
          path="/"
          element={
            <ProtectedRoute>
              <GlobalLayout>
                <EnhancedConsortiumList />
              </GlobalLayout>
            </ProtectedRoute>
          }
        /> */}

<Route
        path="/consortium/:consortiumId/"
        element={
          <ProtectedRoute>
            <GlobalLayout bgcolor="#fff">
                <EnhancedConsortiumDetail />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

<Route
        path="/consortium/:consortiumId/edit/"
        element={
          <ProtectedRoute>
            <GlobalLayout bgcolor="#fff">
                <EditConsortium />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

<Route
        path="/hub/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <CollaborationHub />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/connections/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
              <ConnectionsPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/works/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
              <WorksPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/interests/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
              <InterestsPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

<Route
        path="/positions/:positionId/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <PositionPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

<Route
        path="/lab/:labId/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <LabPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

<Route
        path="/organization/:id/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <OrganizationPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

<Route
        path="/organization/:orgId/department/:deptId/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <DepartmentPage />
            </GlobalLayout>
          </ProtectedRoute>
        }
      />

{/* <Route
        path="/profile/:profileId/settings/"
        element={
          <ProtectedRoute>
            <GlobalLayout>
                <EnhancedProfileSettings />
            </GlobalLayout>
          </ProtectedRoute>
          }
       /> */}

 {/* HEU PAGES */}

<Route path="/organization/" element={   
        <ProtectedRoute>
           <GlobalLayout><Organization /></GlobalLayout>
        </ProtectedRoute>
        
        } />


<Route path="/organizations/" element={
    <ProtectedRoute>
        <GlobalLayout><OrganizationsPage /></GlobalLayout>
    </ProtectedRoute>
    } />

{/* FUNDING PAGES */}
      <Route path="/funding/" element={
        <ProtectedRoute>
          <GlobalLayout><FundingCallsPage /></GlobalLayout>
        </ProtectedRoute>} />
      <Route path="/funding-calls/" element={
        
        <ProtectedRoute>
             <GlobalLayout><FundingCallsPage /></GlobalLayout>
        </ProtectedRoute>
        
        } />
      <Route path="/funding/live/" element={
        
        <ProtectedRoute>
          <GlobalLayout><HorizonEuropeIntegration /></GlobalLayout>
        </ProtectedRoute>} />
      {/* <Route path="/funding/program/:programId" element={<GlobalLayout><ProgramDetailPage /></GlobalLayout>} /> */}
      <Route path="/funding/call/:callId/experts" element={
           <ProtectedRoute>
              <GlobalLayout>
                  <AllSuggestedExpertsPage />
                </GlobalLayout>
            </ProtectedRoute>
        } />
      <Route path="/funding/call/:callId" element={
           <ProtectedRoute>
              <GlobalLayout><CallDetailPage /></GlobalLayout>
            </ProtectedRoute>
        } />
      <Route path="/funding/call/:callId/" element={
           <ProtectedRoute>
              <GlobalLayout><CallDetailPage /></GlobalLayout>
            </ProtectedRoute>
        } />
      <Route path="/funding/call/:callId/*" element={
           <ProtectedRoute>
              <GlobalLayout><CallDetailPage /></GlobalLayout>
            </ProtectedRoute>
        } />




      <Route path="/suggestions/sent/" element={
        
        <ProtectedRoute>
              <GlobalLayout><MySuggestions /></GlobalLayout>
        </ProtectedRoute>
      } />
      
      
      <Route path="/suggestions/received/" element={
        <ProtectedRoute>
          <GlobalLayout><SuggestionList /></GlobalLayout>
        </ProtectedRoute>
      } />

      <Route path="/suggestions/" element={
          <ProtectedRoute> 
            <GlobalLayout><ModernSuggestionsPage /></GlobalLayout>
        </ProtectedRoute>
      } />
      <Route path="/all-suggestions/" element={<GlobalLayout><AllSuggestions /></GlobalLayout>} />
      
      
      
      
      <Route path="/notifications/" element={
           <ProtectedRoute>
                <GlobalLayout>
                    <EnhancedNotificationSystem />
                </GlobalLayout>
        </ProtectedRoute>
        } />
      
  
      
      <Route path="/social/followed/" element={
           <ProtectedRoute>
                 <GlobalLayout>
                    <FollowedEntitiesPage />
                  </GlobalLayout>
        </ProtectedRoute>
        } />
      
      
      <Route path="/messages/" element={
           <ProtectedRoute>
              <GlobalLayout><MessagesPage /></GlobalLayout>
        </ProtectedRoute>
        } />
      <Route path="/messages/new/" element={
           <ProtectedRoute>
              <GlobalLayout><SendMessagePage /></GlobalLayout>
        </ProtectedRoute>
        } />
      
      <Route path="/events/" element={
        <ProtectedRoute>
          <GlobalLayout><EventsPage /></GlobalLayout>
        </ProtectedRoute>
      } />
      <Route path="/events/calendar/" element={
        <ProtectedRoute>
          <GlobalLayout><MyCalendarPage /></GlobalLayout>
        </ProtectedRoute>
      } />
      <Route path="/events/:eventId/" element={
        <ProtectedRoute>
          <GlobalLayout><EventDetailPage /></GlobalLayout>
        </ProtectedRoute>
      } />

      {/* Admin Routes */}
      <Route 
        path="/admin/verify-memberships/" 
        element={
          <AdminRoute>
            <GlobalLayout>
              <VerifyMembershipsPanel />
            </GlobalLayout>
          </AdminRoute>
        } 
      />
      <Route 
        path="/admin/reports/" 
        element={
          <AdminRoute>
            <GlobalLayout>
              <AdminReportsPage />
            </GlobalLayout>
          </AdminRoute>
        } 
      />
      <Route
        path="/admin/analytics/"
        element={
          <AdminRoute>
            <GlobalLayout>
              <AdminAnalyticsPage />
            </GlobalLayout>
          </AdminRoute>
        }
      />
      <Route
        path="/admin/profile-reminders/"
        element={
          <AdminRoute>
            <GlobalLayout>
              <AdminProfileRemindersPage />
            </GlobalLayout>
          </AdminRoute>
        }
      />
      <Route
        path="/admin/call-updates/"
        element={
          <AdminRoute>
            <GlobalLayout>
              <AdminCallUpdatesPage />
            </GlobalLayout>
          </AdminRoute>
        }
      />
      <Route
        path="/admin/emails/"
        element={
          <AdminRoute>
            <GlobalLayout>
              <AdminBulkEmailPage />
            </GlobalLayout>
          </AdminRoute>
        }
      />
      <Route
        path="/admin/releases/"
        element={
          <AdminRoute>
            <GlobalLayout>
              <AdminReleasesPage />
            </GlobalLayout>
          </AdminRoute>
        }
      />
      <Route
        path="/admin/ai-credits/"
        element={
          <AdminRoute>
            <GlobalLayout>
              <AdminAICreditsPage />
            </GlobalLayout>
          </AdminRoute>
        }
      />
{/* 
    <Route 
        path="/admin/send-emails/" 
        element={
          <ProtectedRoute>
            <GlobalLayout>
              <SendEmailsPage />
            </GlobalLayout>
          </ProtectedRoute>
        } 
      /> */}
      
      {/* Video Meeting Route */}
      {/* <Route 
        path="/meeting/:roomSlug" 
        element={
          <ProtectedRoute>
            <GlobalLayout hideNavigation>
              <MeetingPage />
            </GlobalLayout>
          </ProtectedRoute>
        } 
      /> */}
      
      <Route
        path="/dev/notifications/"
        element={
          <SuperuserRoute>
            <GlobalLayout>
              <NotificationTestPage />
            </GlobalLayout>
          </SuperuserRoute>
        }
      />

      <Route path="*" element={<NotFoundPage />}/>

</Routes>

      </NotificationProvider>
</SnackbarProvider>
    </FollowCacheProvider>
    </UserStatusProvider>
      </MuiLocaleProvider>
      </LocaleProvider>
    </UserProvider>
    </ErrorBoundary>
  );
};

export default App;

